import { DSSpacer, DSText } from '@zoe/ds-web'
import styled from 'styled-components'

import { BASE_WEBSITE_LOCALES, EU_LOCALES, FOOD_TERMS_LOCALES, LOCALE_US } from '@/types/locales'

import { useLocale } from '@/context/localeContext'

import { DSLinkText } from '@/components/ds/LinkText/LinkText'

import { openCookiePreferences } from '@/lib/consent'
import { getTermsPath } from '@/lib/legal/terms'

import { trackFooterClick } from './Footer'

const StyledMenuContainer = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    transition: transform 0.3s ease-in-out;
    max-width: 200px;
    &:hover {
      transform: translateY(-2px);
    }
  }
`

export const FooterLegalMenu: React.FC = () => {
  const { currentLocale, baseLocale } = useLocale()
  const isBaseLocale = BASE_WEBSITE_LOCALES.includes(currentLocale)
  const showFoodTerms = FOOD_TERMS_LOCALES.includes(currentLocale)

  const handleCookiePreferencesClick = () => {
    trackFooterClick('Cookie preferences')
    openCookiePreferences()
  }

  return (
    <StyledMenuContainer>
      <DSText as="h5" variant="fluid-label-100" weight="semiBold" color="primary-inverse">
        Legal
      </DSText>
      <DSSpacer size={16} direction="vertical" />
      <ul>
        {isBaseLocale && (
          <li>
            <DSLinkText
              href={getTermsPath(baseLocale, 'membership')}
              onPress={() => trackFooterClick('Terms of Service (Membership)')}
            >
              <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                Terms of Service (Membership)
              </DSText>
            </DSLinkText>
            <DSSpacer size={12} direction="vertical" />
          </li>
        )}

        {showFoodTerms && (
          <>
            <li>
              <DSLinkText
                href={getTermsPath(currentLocale, 'food')}
                onPress={() => trackFooterClick('Terms of Service (Food Products)')}
              >
                <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                  Terms of Service (Food Products)
                </DSText>
              </DSLinkText>
            </li>
            <DSSpacer size={12} direction="vertical" />
          </>
        )}

        {currentLocale === LOCALE_US && (
          <>
            <li>
              <DSLinkText
                href="/consumer-health-data-privacy-notice"
                onPress={() => trackFooterClick('Consumer Health Data Privacy Notice')}
              >
                <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                  Consumer Health Data Privacy Notice
                </DSText>
              </DSLinkText>
            </li>
            <DSSpacer size={12} direction="vertical" />
          </>
        )}
        <li>
          <DSLinkText
            href={EU_LOCALES.includes(currentLocale) ? `/${currentLocale}/daily30/privacy-policy` : '/privacy-policy'}
            onPress={() => trackFooterClick('Privacy policy')}
          >
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Privacy policy
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText href="/cookie-policy" onPress={() => trackFooterClick('Cookie policy')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Cookie policy
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText href="#" onPress={handleCookiePreferencesClick}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Cookie preferences
            </DSText>
          </DSLinkText>
        </li>
        {currentLocale === LOCALE_US && (
          <li>
            <DSSpacer size={12} direction="vertical" />
            <DSLinkText
              href="https://privacy.zoe.com/zoe"
              onPress={() => trackFooterClick('Do not sell or share my personal information')}
            >
              <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
                Do not sell or share my personal information
              </DSText>
            </DSLinkText>
          </li>
        )}
      </ul>
    </StyledMenuContainer>
  )
}
